<template>
  <ul :class="classObject">
    <li
      class="c-navigation-list__item"
      :class="{ 'is-admin-menu': link.is_admin_menu }"
      v-for="(link, index) in displayLinks"
      :key="index"
    >
      <app-navigation-link
        :link="link"
        @dropdown-click="onLinkDropdownClick(link)"
      ></app-navigation-link>
      <app-navigation-list
        :links="link.children"
        :isAdmin="link.is_admin_menu"
        :isSmall="link.small_child_menu"
        :isOpen="link.isOpen"
        :isSuper="link.isSuper"
        :groups="link.groups"
      ></app-navigation-list>
    </li>
  </ul>
</template>

<script>
import Vue from "vue";
import AppNavigationLink from "@/components/AppNavigationLink";

export default {
  name: "app-navigation-list",

  components: {
    AppNavigationLink,
  },

  props: {
    links: Array,
    isOpen: Boolean,
    isAdmin: Boolean,
    isSmall: Boolean,
    isSuper: {
      type: Boolean,
      default: false,
    },
    groups: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    displayLinks() {
      if (this.links) {
        return this.links.filter((link) => this.isVisible(link));
      }
      return [];
    },
    classObject(link) {
      return {
        "c-navigation-list": true,
        "c-navigation-list--small": this.isSmall,
        "is-admin-menu": this.isAdmin,
        "is-open": this.isOpen,
      };
    },
  },

  methods: {
    onLinkDropdownClick(link) {
      Vue.set(link, "isOpen", !link.isOpen);
    },

    isVisible(link) {
      /**
       * Logic for determining if a menu is visible or not
       * If the user is base only, hide the admin menu
       * IF an admin link is inteded for super admins only, show it
       * If the link is for specific user groups:
       *  - Super admins can see it
       *  - If the link has no groups, and not a super admin, hide it
       *  - If the user is not a super admin, check the groups and compare against the users groups
       */
      if (link.is_admin_menu) {
        //TODO: Just hide this menu for base users as all other groups may have admin links
        //are we in the admin group?
        if (this.$store.state.auth.currentUser) {
          const { privilege_groups } = this.$store.state.auth.currentUser;
          if (!privilege_groups || privilege_groups.length == 0) {
            return false;
          }
          const userGroups = Object.keys(privilege_groups).filter(
            (key) => privilege_groups[key] === true
          );
          //these groups have no need to be in the admin area
          return !(
            userGroups.length == 1 &&
            ["user"].includes(userGroups[0])
          ); // TODO: Super admins will always be part of the admin group, right?
        }
        //if the link is for super only, we need to only show it for supers
        if (link.isSuper) {
          return !!this.$store.state.auth.superAdmin;
        }
      }

      //if the link has groups on it, is the user a member of all the groups?
      if (link.groups) {
        // if we are a super admin, show the link
        if (this.$store.state.auth.superAdmin) {
          return true;
        }

        // if there are no groups, and we are not a super admin, hide the menu
        if (link.groups.length == 0 && !this.$store.state.auth.superAdmin) {
          return false;
        }

        // Get a list of groups the user is a member of
        const { privilege_groups } = this.$store.state.auth.currentUser;
        const userGroups = Object.keys(privilege_groups).filter(
          (key) => privilege_groups[key] === true
        );

        const matchedGroups = userGroups.filter((grp) =>
          link.groups.includes(grp)
        );

        //TODO: Do we need to match ALL groups or just a singular group?
        return matchedGroups.length > 0; // one group
        return matchedGroups.length === link.groups.length; // all groups
      }

      return true;
    },
  },
};
</script>

<style lang="scss">
.c-navigation-list {
  height: 100%;

  padding-bottom: 200px !important;

  .c-navigation-list {
    padding-bottom: 0 !important;
  }

  // fix IE scrollbars
  -ms-overflow-style: none;

  overflow-y: auto;
  overflow-x: hidden;

  &__item &:not(.is-open) {
    display: none;
  }

  &__item {
    border-top: 1px solid rgba(0, 0, 0, 0.15);
  }

  .c-navigation.is-closed & &--small {
    display: none;
  }

  &--small {
    background: #34414c;
    box-shadow: inset 0px 4px 6px rgba(0, 0, 0, 0.09);
  }

  &--small &__item {
    border: none;
  }

  &--small .c-navigation-link {
    font-size: 16px;
    padding-top: 0.75em;
    padding-bottom: 0.75em;
    height: auto;
    transition: none;
    border: none;
    color: rgba(255, 255, 255, 0.6);
    background: $colour-nhs-bright-blue;

    &__text {
      transition: none;
    }

    &:hover {
      color: $colour-nhs-white;
    }
  }

  &--small .c-navigation-link.is-active {
    // background: inherit;
  }

  &--small .c-navigation-link__icon {
    visibility: hidden;
    opacity: 0;
    transition: none;
  }

  &--small .c-navigation-link:hover .c-navigation-link__icon {
    visibility: visible;
    opacity: 1;
  }

  .is-admin-menu {
    background: $colour-nhs-dark-grey;

    .c-navigation-link {
      background: $colour-nhs-dark-grey;
    }
  }
}
</style>
